import { useEffect } from 'react';
import { logoutCurrentUser } from '../../auth/auth';

export default function LogOutPage() {
    useEffect(() => {
        logoutCurrentUser().catch(err => {
            console.error('Failed to logout current user:', err);
        });
    }, []);

    return null;
}
